import React, { useState } from 'react';
import Layout from '../../components/layout';
import { Form } from 'react-bootstrap';
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { isEmpty } from '../../lib/common';
import { sendSubscriberMail } from '../../axioscalls/useaxios';

const SubscriberAdd = () => {


    const navigate = useNavigate();


    const [validateError, setValidateError] = useState({});
    const [subject, setsubject] = useState("");
    const [mailData, setMailData] = useState("");

    const onChange = (e) => {
        setsubject(e.target.value)
        
        setValidateError({})
    }
    const onEditorChange = (evt) => {
        setMailData(evt);
        setValidateError({})
    }

    const Validate = (data) => {
        let errors = {};
        if (isEmpty(data?.subject)) {
            errors.subject = "Subject Required"
        }
        if (isEmpty(data?.boc)) {
            errors.boc = "Content required"
        }
        return errors
    }

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        let reqData = {
            subject: subject,
            boc: mailData

        }
        let errors = Validate(reqData);
        if (isEmpty(errors)) {
            setValidateError({})
            let sentSubMail = await sendSubscriberMail(reqData);
            
            if (sentSubMail && sentSubMail?.data && sentSubMail?.data?.data && sentSubMail?.data?.data && sentSubMail?.data?.data?.data?.success && sentSubMail?.data?.data?.data?.success == true) {
                toast.success(sentSubMail.data.data.data.message, 1000);
                navigate("/subscriberlist");
            } else {
                toast.warning((sentSubMail?.data?.data?.data?.message?sentSubMail.data.data.data.message:"Oops something went wrong"), 1000);
            }

        }
        else {
            toast.error("Fix all validations", 1000)
            setValidateError(errors);
        }
    }

    return (
        <Layout>
            <div className="subscriberadd">
            <button type='button' onClick={()=>navigate("/subscriberlist")} className="btn allbtn text-decoration-none sitebtn mb-4">Back</button>
                <h3 className="pagehead">Create News Letter</h3>
                <div className="cardbox">
                    <Form className='mb-4'>
                        <Form.Label>Subject</Form.Label>
                        <Form.Control type="text" placeholder="Subject" className="w-auto mb-2" onChange={onChange}
                            id="subject" value={subject || ''} />
                        {
                            validateError.subject && <span className="error_msg mb-2">{validateError.subject}</span>
                        }
                    </Form>

                    <Form.Label>Content:</Form.Label>
                    <SunEditor height={200} onChange={onEditorChange} placeholder='Content for mail' />
                    <div className='mt-2'>
                        {
                            validateError.boc && <span className="error_msg">{validateError.boc}</span>
                        }
                    </div>
                    
                    <button type="button" className="btn allbtn text-decoration-none sitebtn py-2 px-3 mt-4" onClick={handleFormSubmit}>Send</button>
                </div>
            </div>
        </Layout>
    )
}

export default SubscriberAdd;